export const defaultFilter = {
	organo: '',
	sector: '',
	institucion: '',
	nombre: '',
	tipoUsuario: '',
	estatus: 'A',
};

export const filter_form = (
	onValidate,
	onSearch,
	onClear,
	organs = [],
	institutions = [],
	byAdvisor,
	type,
	permission
) => [
	{
		label: 'Órgano Colegiado:',
		name: 'organo',
		type: 'dropdown',
		options: [...organs],
		column: type ? 5 : 3,
	},
	!type && {
		label: 'Representación',
		name: 'sector',
		type: 'dropdown',
		options: [
			{ value: 'SG', text: 'Sector Gobierno' },
			{ value: 'ST', text: 'Sector Trabajador' },
			{ value: 'SE', text: 'Sector Empresarial' },
		],
		column: 2,
	},
	{
		label: 'Unidad Administrativa:',
		name: 'institucion',
		type: 'dropdown',
		options: [...institutions],
		column: 3,
	},
	{
		label: 'Tipo de Usuario',
		name: 'tipoUsuario',
		type: 'dropdown',
		options: [
			{ value: 'I', text: 'Interno' },
			{ value: 'E', text: 'Externo' },
		],
		column: 2,
	},
	permission && {
		label: 'Estatus',
		name: 'estatus',
		type: 'dropdown',
		options: [
			{ value: 'A', text: 'Activo' },
			{ value: 'I', text: 'Inactivo' },
		],
		column: 2,
	},
	{
		label: 'Búsqueda por Nombre de Usuario',
		name: 'BusquedaporCosejero',
		color: 'light-primary',
		type: 'button',
		onClick: onValidate,
		column: 2,
		style: { width: '100%' },
	},
	byAdvisor === true && {
		label: 'Introduce el Nombre del Usuario',
		name: 'nombre',
		type: 'text',
		column: 7,
	},
	byAdvisor === false && {
		type: 'inner-column',
		column: 7,
	},
	{
		label: 'Limpiar',
		name: 'Limpiar',
		color: 'primary',
		type: 'button',
		onClick: onClear,
		column: 1,
		style: { width: '100%' },
	},
	{
		label: 'Buscar',
		name: 'nombre',
		color: 'info',
		type: 'button',
		onClick: onSearch,
		column: 2,
		style: { width: '100%' },
	},

	{
		dataField: 'estatus',
		text: 'Activo',
		style: { maxWidth: '180px', whiteSpace: 'nowrap', textAlign: 'center' },
		formatter: (cell) => {
			const isActive = cell === 'A' || cell === 'Activo';
			const color = isActive ? 'green' : 'red';
			const label = isActive ? 'Activo' : 'Inactivo';

			return (
				<span
					style={{
						backgroundColor: color,
						color: 'white',
						padding: '4px 10px',
						borderRadius: '12px',
						fontWeight: 'bold',
						display: 'inline-block',
						minWidth: '70px',
					}}
				>
					{label}
				</span>
			);
		},
	},
];

export const columns = (hide) => [
	hide
		? ''
		: {
				dataField: 'usuario',
				text: 'Usuario',
				style: { maxWidth: '180px', whiteSpace: 'nowrap', textAlign: 'center' },
		  },
	{
		dataField: 'nombre',
		text: 'Nombre',
		style: { maxWidth: '180px', whiteSpace: 'nowrap', textAlign: 'center' },
	},
	{
		dataField: 'apellidoPaterno',
		text: 'Apellido Paterno',
		style: { maxWidth: '180px', whiteSpace: 'nowrap', textAlign: 'center' },
	},
	{
		dataField: 'apellidoMaterno',
		text: 'Apellido Materno',
		style: { maxWidth: '180px', whiteSpace: 'nowrap', textAlign: 'center' },
	},
	{
		dataField: 'unidadAdministrativa',
		text: 'Org / Depend',
		style: { maxWidth: '180px', whiteSpace: 'nowrap', textAlign: 'center' },
	},
	{
		dataField: 'cargo',
		text: 'Representación',
		style: { maxWidth: '180px', whiteSpace: 'nowrap', textAlign: 'center' },
	},
	{
		dataField: 'seccion',
		text: 'Sector',
		style: { maxWidth: '180px', whiteSpace: 'nowrap', textAlign: 'center' },
	},
	{
		dataField: 'domicilio',
		text: 'Domicilio',
		style: { maxWidth: '250px', whiteSpace: 'nowrap', textAlign: 'center' },
	},
	{
		dataField: 'telefono',
		text: 'Teléfono',
		style: { maxWidth: '180px', whiteSpace: 'nowrap', textAlign: 'center' },
	},
	{
		dataField: 'email',
		text: 'Correo Electrónico',
		style: { maxWidth: '250px', whiteSpace: 'nowrap', textAlign: 'center' },
	},
	{
		dataField: 'oficio',
		text: 'Oficio',
		style: { maxWidth: '180px', whiteSpace: 'nowrap', textAlign: 'center' },
	},
	{
		dataField: 'perfil',
		text: 'Perfil',
		style: { maxWidth: '180px', whiteSpace: 'nowrap', textAlign: 'center' },
	},
	{
		dataField: 'organos',
		text: 'Órganos Colegiados',
		style: { maxWidth: '250px', whiteSpace: 'nowrap', textAlign: 'center' },
		// formatter: (cell, row) => {
		// 	let uniqueProfiles;
		// 	if (row?.organos?.length > 0) {
		// 		uniqueProfiles = [
		// 			...new Set(row.organos.map((item) => `${item.nombre}\n`)),
		// 		];
		// 	}
		// 	return uniqueProfiles;
		// },
	},
	{
		dataField: 'estatus',
		text: 'Activo',
		style: { maxWidth: '180px', whiteSpace: 'nowrap', textAlign: 'center' },
		formatter: (cell) => {
			const isActive = cell === 'Activo';
			const label = isActive ? 'Activo' : 'Inactivo';
			const color = isActive ? 'green' : 'red';
			return (
				<span
					style={{
						backgroundColor: color,
						color: 'white',
						padding: '4px 10px',
						borderRadius: '12px',
						fontWeight: 'bold',
						display: 'inline-block',
						minWidth: '70px',
					}}
				>
					{label}
				</span>
			);
		},
	},
];

export const columnsFilial = (hide) => [
	hide
		? ''
		: {
				dataField: 'usuario',
				text: 'Usuario',
				style: { maxWidth: '180px', whiteSpace: 'nowrap', textAlign: 'center' },
		  },
	{
		dataField: 'nombre',
		text: 'Nombre',
		style: { maxWidth: '180px', whiteSpace: 'nowrap', textAlign: 'center' },
	},
	{
		dataField: 'apellidoPaterno',
		text: 'Apellido Paterno',
		style: { maxWidth: '180px', whiteSpace: 'nowrap', textAlign: 'center' },
	},
	{
		dataField: 'apellidoMaterno',
		text: 'Apellido Materno',
		style: { maxWidth: '180px', whiteSpace: 'nowrap', textAlign: 'center' },
	},

	{
		dataField: 'cargo',
		text: 'Representación',
		style: { maxWidth: '180px', whiteSpace: 'nowrap', textAlign: 'center' },
	},

	{
		dataField: 'email',
		text: 'Correo Electrónico',
		style: { maxWidth: '250px', whiteSpace: 'nowrap', textAlign: 'center' },
	},
	{
		dataField: 'perfil',
		text: 'Perfil',
		style: { maxWidth: '180px', whiteSpace: 'nowrap', textAlign: 'center' },
	},
	{
		dataField: 'organos',
		text: 'Órganos Colegiados',
		style: { maxWidth: '250px', whiteSpace: 'nowrap', textAlign: 'center' },
		// formatter: (cell, row) => {
		// 	let uniqueProfiles;
		// 	if (row?.organos?.length > 0) {
		// 		uniqueProfiles = [
		// 			...new Set(row.organos.map((item) => `${item.nombre}\n`)),
		// 		];
		// 	}
		// 	return uniqueProfiles;
		// },
	},
	{
		dataField: 'estatus',
		text: 'Activo',
		style: { maxWidth: '180px', whiteSpace: 'nowrap', textAlign: 'center' },
		formatter: (cell) => {
			const isActive = cell === 'Activo';
			const label = isActive ? 'Activo' : 'Inactivo';
			const color = isActive ? 'green' : 'red';
			return (
				<span
					style={{
						backgroundColor: color,
						color: 'white',
						padding: '4px 10px',
						borderRadius: '12px',
						fontWeight: 'bold',
						display: 'inline-block',
						minWidth: '70px',
					}}
				>
					{label}
				</span>
			);
		},
	},
];

export const columns2 = (hide) => [
	hide
		? ''
		: {
				dataField: 'usuario',
				text: 'Usuario',
				style: { maxWidth: '180px', whiteSpace: 'nowrap', textAlign: 'center' },
		  },
	{
		dataField: 'nombre',
		text: 'Nombre',
		style: { maxWidth: '180px', whiteSpace: 'nowrap', textAlign: 'center' },
	},
	{
		dataField: 'apellidoPaterno',
		text: 'Apellido Paterno',
		style: { maxWidth: '180px', whiteSpace: 'nowrap', textAlign: 'center' },
	},
	{
		dataField: 'apellidoMaterno',
		text: 'Apellido Materno',
		style: { maxWidth: '180px', whiteSpace: 'nowrap', textAlign: 'center' },
	},
	{
		dataField: 'unidadAdministrativa',
		text: 'Unidad Administrativa',
		style: { maxWidth: '250px', whiteSpace: 'nowrap', textAlign: 'center' },
	},
	{
		dataField: 'cargo',
		text: 'Representación',
		style: { maxWidth: '250px', whiteSpace: 'nowrap', textAlign: 'center' },
	},
	{
		dataField: 'FullLinkName',
		text: 'Nombre Completo',
		style: { maxWidth: '250px', whiteSpace: 'nowrap', textAlign: 'center' },
	},
	{
		dataField: 'email',
		text: 'Correo Electrónico',
		style: { maxWidth: '250px', whiteSpace: 'nowrap', textAlign: 'center' },
	},
	{
		dataField: 'perfil',
		text: 'Perfil',
		style: { maxWidth: '180px', whiteSpace: 'nowrap', textAlign: 'center' },
	},
	{
		dataField: 'organos',
		text: 'Órganos Colegiados',
		style: { maxWidth: '250px', whiteSpace: 'nowrap', textAlign: 'center' },
		// formatter: (cell, row) => {
		// 	let uniqueOrgan;
		// 	if (row?.organos?.length > 0) {
		// 		uniqueOrgan = [...new Set(row.organos.map((item) => `${item.nombre}\n`))];
		// 		return uniqueOrgan;
		// 	}
		// },
	},
];
